// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox7":"L7_exerciseBox7__26SZI","mspacing":"L7_mspacing__1Lp2_","mspacing2":"L7_mspacing2__xVrNH"};